import { setCanvasDimensions, theLoop } from './artwork'
import { initGlobalState } from './lib/globalState'
import { showSVGExportButton } from './export-button'
import { SHOW_EXPORT_BUTTON, VERSION } from './const'
import { getSettings } from './lib/settings'
import { stats } from './lib/fps'

let canvas: HTMLCanvasElement

window.addEventListener('resize', () => {
  window.location.reload()
})

export default function main() {
  const rootContainer = document.getElementById('root')
  if (!rootContainer) throw new Error('no root element found')

  if (getSettings().showStatistics) {
    stats.showPanel(0)
    document.body.appendChild(stats.dom)
    createDebugPanel()
  }

  canvas = document.createElement('canvas')
  canvas.id = 'artwork'
  setCanvasDimensions(canvas)

  const ctx = canvas.getContext('webgl')
  if (!ctx) throw new Error('could not get webgl rendering context')
  rootContainer.appendChild(canvas)
  const globalState = initGlobalState()
  if (SHOW_EXPORT_BUTTON) showSVGExportButton(globalState)

  theLoop(canvas, ctx, globalState)
}

let debugPanel: HTMLDivElement | undefined = undefined

function createDebugPanel() {
  debugPanel = document.createElement('div')
  debugPanel.id = 'debug-panel'

  debugPanel.style.position = 'fixed'
  debugPanel.style.right = '0'
  debugPanel.style.top = '0'
  debugPanel.style.backgroundColor = 'rgba(0,0,0,0.25)'
  debugPanel.style.color = 'white'
  debugPanel.style.fontFamily = 'monospace'
  debugPanel.style.boxSizing = 'border-box'
  debugPanel.style.padding = '2px'
  document.body.appendChild(debugPanel)
}

export function setDebugText(s: string): void {
  if (!debugPanel) return
  debugPanel.innerHTML = `v${VERSION} - ${s}`
}
